import Vue from 'vue'
import Router from 'vue-router'
import Portal from './views/Portal_all.vue'
import GlpmFindCards from './views/Glpm/GlpmFindCards.vue'
import Home from './views/Home.vue'
import JournalPpn from '@/components/glpm/ppnCards.vue'
import store from './store' // your vuex store 
Vue.use(Router)
const ifAuthenticated = (to, from, next) => {
  console.log(store.getters.authenticated)
  if (store.getters.authenticated) {
    next()
    return
  }
  next('/otdeldn')
}
export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Portal
    },
    {
      path: '/glpm',
      name: 'glpm',
      redirect: { name: "glpmfind" },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Glpm/Glpm.vue'),
      children: [
        {
          path: 'find',
          name: 'glpmfind',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ './views/Glpm/GlpmFindCards.vue'),
          children: [
            {
              path: 'ppn',
              name: 'ppn',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
              component: () => import(/* webpackChunkName: "about" */ './views/Glpm/GlpmFindCards.vue')
            },
            {
              path: 'lpt',
              name: 'lpt',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
              component: JournalPpn
            }
          ]
        },
        {
          path: 'ppn/:id',
          name: 'ppnbyid',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "about" */ './views/Home.vue')
        }
      ]
    },
    {
      path: '/otdeldn',
      name: 'otdeldn',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/otdelDn.vue')
    },
    {
      path: '/dn61',
      name: 'dn61',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/dn61.vue')
    },
    {
      path: '/planedit',
      name: 'planedit',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/planEdit.vue'),
      props: (route) => ({ filialid: route.query.filialid }),
      beforeEnter: ifAuthenticated
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Login.vue')
    }
  ]
})